import React from 'react';
import { Globe, Search, Shield, BarChart, AlertCircle } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

export const DomainsFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Domain Asset Management"
      description="Discover, monitor, and manage all your domain assets in one place. Gain visibility into your external attack surface and identify potential security risks."
      icon={<Globe className="h-8 w-8 text-blue-600" />}
      featureName="domains"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Search className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Domain Discovery</h3>
          </div>
          <p className="text-gray-400">
            Automatically discover and inventory all your organization's domains with comprehensive scanning and monitoring.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Shield className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Security Monitoring</h3>
          </div>
          <p className="text-gray-400">
            Monitor domains for security issues, misconfigurations, and potential vulnerabilities with real-time alerts.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <BarChart className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Risk Assessment</h3>
          </div>
          <p className="text-gray-400">
            Assess the security posture of your domains with comprehensive risk scoring and prioritization.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <AlertCircle className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Threat Intelligence</h3>
          </div>
          <p className="text-gray-400">
            Integrate threat intelligence data to identify malicious activities targeting your domain assets.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};


